class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
    this.setupProductTypeFilter();
    this.setupVoiceSearch();
  }

  // 🔹 Setup Product Type Filter
  setupProductTypeFilter() {
    const typeFilter = document.querySelector('.js-search-product-types select');
    const hiddenInput = document.querySelector('#product_type_input');

    if (!typeFilter || !hiddenInput) return;

    typeFilter.addEventListener('change', () => {
      hiddenInput.value = typeFilter.value;
      const query = this.getQuery();
      if (query.length > 0) this.onChange(); // Trigger predictive results refresh
    });
  }

  // 🔹 Setup Voice Search
  setupVoiceSearch() {
    const voiceBtn = this.querySelector('.voice-search__button');
    const searchInput = this.querySelector('input[name="q"]');

    if (!voiceBtn || !('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
      if (voiceBtn) voiceBtn.style.display = 'none';
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();

    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    voiceBtn.addEventListener('click', () => {
      recognition.start();
      voiceBtn.classList.add('listening');
    });

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      searchInput.value = transcript;
      this.onChange(); // Trigger predictive search instantly
    };

    recognition.onerror = (event) => console.error('Voice Search Error:', event.error);
    recognition.onend = () => voiceBtn.classList.remove('listening');
  }

  // 🔹 Setup Events (fixed to use Dawn’s default handlers)
  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('input', this.onChange.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  // 🔹 Fetch predictive search results (with product type filter)
  getSearchResults(searchTerm) {
  const typeFilter = document.querySelector('.js-search-product-types select');
  const productType = typeFilter && typeFilter.value ? typeFilter.value.trim() : '';

  // Combine product type and search term for broader matching
  const query = productType ? `${productType} ${searchTerm}` : searchTerm;

  this.abortController.abort();
  this.abortController = new AbortController();

  const queryKey = query.replaceAll(' ', '-').toLowerCase();
  this.searchTerm = query;
  this.setAttribute('loading', true);

  if (this.cachedResults[queryKey]) {
    this.renderResults(this.cachedResults[queryKey]);
    return;
  }

  fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`, {
    signal: this.abortController.signal,
  })
    .then((res) => res.json())
    .then((data) => {
      this.cachedResults[queryKey] = data;
      this.renderResults(data);
    })
    .catch((err) => {
      if (err.name !== 'AbortError') console.error('Predictive Search Error:', err);
    });
}


  onFormSubmit(event) {
    const query = this.getQuery();
    if (!query.length) event.preventDefault();
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (currentSearchTerm.length && this.searchTerm !== currentSearchTerm) this.onChange();
    else if (this.getAttribute('results') === 'true') this.open();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (newSearchTerm.length === 0) {
      this.close(true);
      return;
    }
    this.getSearchResults(newSearchTerm);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    if (event.code === 'ArrowUp') this.switchOption('up');
    if (event.code === 'ArrowDown') this.switchOption('down');
    if (event.code === 'Enter') this.selectOption();
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') event.preventDefault();
  }

  renderResults(data) {
    const resultsMarkup = data.resources?.results?.products?.length
      ? data.resources.results.products
          .map(
            (p) => `
        <ul class="predictive-search__results-list list-unstyled"role="group"aria-labelledby="predictive-search-queries"> <li class="predictive-search__list-item"role="option"aria-selected="false"> <a href="${p.url}" class="predictive-search__item link link--text" tabindex="-1"> <div class="predictive-search__item-content predictive-search__item-content--centered"><img src="${p.image}" alt="${p.title}" width="60" height="60" style="object-fit:contain;border-radius:4px;background:#fff;"> <p class="predictive-search__item-heading predictive-search__item-query-result h5"aria-label="{{ query.text }}">${p.title} </p> </div> </a> </li> </ul>`
          )
          .join('')
      : '<p class="predictive-search__no-results">No products found.</p>';

    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.removeAttribute('loading');
    this.setAttribute('results', true);
    this.open();
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = `${window.innerHeight - 100}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clear = false) {
    if (clear) this.input.value = '';
    this.removeAttribute('results');
    this.predictiveSearchResults.innerHTML = '';
    this.removeAttribute('open');
    this.removeAttribute('loading');
    this.input.setAttribute('aria-expanded', false);
    this.isOpen = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);
